import React, { Component } from 'react';

export default class SearchIcon extends Component {
	render() {
		return [
			<svg key="0" x="0px" y="0px" viewBox="0 0 100 100"><path d="M62,0C40.9-0.1,23.7,16.9,23.6,38c0,0.1,0,0.1,0,0.2c0,9.5,3.5,18.3,9.3,25l-2.4,2.4c-2.6-1.2-5.7-0.7-7.8,1.4 l-21,21c-2.7,2.7-2.7,7.2,0,9.9c2.7,2.7,7.2,2.7,9.9,0l21-21c2.1-2.1,2.6-5.2,1.4-7.8l2.4-2.4c6.7,6,15.5,9.6,25.2,9.7 c21.1,0.1,38.3-16.9,38.4-38S83.1,0.1,62,0z M62,66.3C46.5,66.4,33.9,54,33.7,38.5c0-0.1,0-0.2,0-0.2c0-15.4,12.4-28,27.8-28.1 C77.1,10,89.8,22.5,89.9,38C90,53.5,77.6,66.2,62,66.3z"/></svg>
		];
	}
}


// WEBPACK FOOTER //
// ./src/icon/SearchIcon.js